import React from 'react';
import { Link } from 'react-router-dom';

const AGENT = ['Copyright Agent', 'Meditative Mindfulness Inc', '1642 Farm To Market Road', 'Denison, TX 75020', 'United States'];

const Body = () => (
  <>
    <p>Osho Universal does not own or claim rights to any historical media. User-generated content must comply with global fair use guidelines. We will immediately remove copyrighted material upon request.</p>
    <p>To report a copyright violation, please send a written notice by <strong>registered / certified mail with recipient signature required</strong> to our designated Copyright Agent:</p>
    <address className="not-italic my-3 pl-4 border-l-2 border-rose/50 text-burgundy">
      {AGENT.map((l, i) => <span key={i} className="block">{l}</span>)}
    </address>
    <p>A copy may also be emailed to <a href="mailto:copyright@oshouniversal.org" className="text-rose-italic hover:underline">copyright@oshouniversal.org</a>, however a signed notice sent by certified mail with signature confirmation is required for any formal takedown action.</p>
    <p>Your written notice must include:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Your full name, mailing address, phone number and email;</li>
      <li>Identification of the copyrighted work you claim has been infringed;</li>
      <li>The exact URL(s) or location of the material on our website;</li>
      <li>A statement that you have a good-faith belief the use is not authorized by the copyright owner, its agent, or the law;</li>
      <li>A statement, made under penalty of perjury, that the information in your notice is accurate and that you are the copyright owner or authorized to act on the owner’s behalf;</li>
      <li>Your physical or electronic signature.</li>
    </ul>
  </>
);

export const CopyrightNotice = ({ compact = false, showPolicyLink = true }) => {
  const link = showPolicyLink ? (
    <p className="pt-1">
      <Link to="/copyright-policy" className="text-rose-italic hover:underline font-medium" data-testid="copyright-policy-link">Read our full Copyright &amp; DMCA Policy →</Link>
    </p>
  ) : null;
  if (compact) {
    return (
      <div className="p-6 rounded-2xl bg-white/70 border border-rose/50 text-sm text-mahogany/80 leading-relaxed space-y-3" data-testid="copyright-notice">
        <div className="font-serif-display text-lg text-burgundy">Copyright &amp; Fair Use</div>
        <Body />
        {link}
      </div>
    );
  }
  return <div data-testid="copyright-notice" className="space-y-3"><Body />{link}</div>;
};

export default CopyrightNotice;
